"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_GAMBLER_SETTINGS_FAIL = exports.GET_GAMBLER_SETTINGS_SUCCESS = exports.GET_GAMBLER_SETTINGS_REQUEST = exports.CHANGE_GAMBLER_SETTINGS_REQUEST = exports.CHANGE_GAMBLER_SETTING_REQUEST = exports.DELETE_GAMBLER_SETTING_REQUEST = exports.NAME = void 0;
exports.NAME = "gambler-settings";
exports.DELETE_GAMBLER_SETTING_REQUEST = exports.NAME + "/DELETE_GAMBLER_SETTING:REQUEST";
exports.CHANGE_GAMBLER_SETTING_REQUEST = exports.NAME + "/CHANGE_GAMBLER_SETTING:REQUEST";
exports.CHANGE_GAMBLER_SETTINGS_REQUEST = exports.NAME + "/CHANGE_GAMBLER_SETTINGS:REQUEST";
exports.GET_GAMBLER_SETTINGS_REQUEST = exports.NAME + "/GET_GAMBLER_SETTINGS:REQUEST";
exports.GET_GAMBLER_SETTINGS_SUCCESS = exports.NAME + "/GET_GAMBLER_SETTINGS:SUCCESS";
exports.GET_GAMBLER_SETTINGS_FAIL = exports.NAME + "/GET_GAMBLER_SETTINGS:FAIL";
//# sourceMappingURL=constants.js.map